// MUライブラリ

import { Box } from "@mui/material";
import Header from "../components/Header";
import ContactSection from "../components/common/ContactSection";
import FooterSection from "../components/common/FooterSection";
import RecruitSection from "../components/common/RecruitSection";
import Top from "./Top";
import Company from "./Company";
import Service from "./Service";
import News from "./News";
import Privacy from "./Privacy";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Box>
        <Header />
        <Routes>
          <Route path="/" element={<Top />} />
          <Route path="/company" element={<Company />} />
          <Route path="/service" element={<Service />} />
          <Route path="/news" element={<News />} />
          <Route path="/privacy" element={<Privacy />} />

          {/* 必要に応じて他のページも追加 */}
        </Routes>
        {/* <RecruitSection /> */}
        <ContactSection />
        <FooterSection />
      </Box>
    </Router>
  );
}

export default App;
